import { BzStockValues, BzTreeMapSectorOrIndustryOptions, Visualization } from '@benzinga/visualization-utils';
import { HeatMap } from './heatmap';
import { HeatMapProps } from './entity';
import { MdGesture } from 'react-icons/md';
const updateTraceItem =
  (
    callback: (trace: HeatMapProps['traces'][0], args: HeatMapProps) => HeatMapProps['traces'][0],
  ): ((args: HeatMapProps, path: number) => HeatMapProps) =>
  (args, path) => {
    const newTrace = callback(args.traces[path], args);
    return {
      ...args,
      traces: args.traces.flatMap((trace, index) => (index === path ? [newTrace] : [trace])),
    };
  };

export const setTraceItem =
  (key: string): ((args: HeatMapProps, value: unknown, path: number) => HeatMapProps) =>
  (args, value, path) => ({
    ...args,
    traces: args.traces.map((trace, index) => (index === path ? { ...trace, [key]: value } : trace)),
  });

export const getTraceItem =
  <T>(key: string): ((args: HeatMapProps, path: number) => T) =>
  (args, path) =>
    args.traces[path][key];

export const HeatMapVisualization: Visualization<HeatMapProps> = {
  defaultArgs: {
    global: {},
    layout: {},
    traces: [
      {
        color: 'changePercent',
        display: 'marketCap',
        groupBy: 'sector',
        name: 'New Heatmap Trace',
        type: 'heatmapWithZoom',
      },
    ],
  },
  editorConfig: {
    traceDeclaration: {
      args: [
        {
          args: [
            {
              get: getTraceItem('display'),
              label: 'Value',
              options: BzStockValues,
              set: setTraceItem('display'),
              type: 'dropdown',
            },
            {
              get: getTraceItem('color'),
              label: 'Color',
              options: BzStockValues,
              set: setTraceItem('color'),
              type: 'dropdown',
            },
            {
              get: getTraceItem('groupBy'),
              label: 'Group By',
              options: BzTreeMapSectorOrIndustryOptions,
              set: setTraceItem('groupBy'),
              type: 'dropdown',
            },
          ],
          enum: 'heatmapWithZoom',
          icon: MdGesture,
          label: 'Heatmap',
          set: updateTraceItem(trace => ({
            ...trace,
            type: 'heatmapWithZoom',
          })),
        },
      ],
    },
  },
  type: 'heatmapWithZoom',
  typeDisplayName: 'HeatMap With Zoom',
  visualization: HeatMap,
};
